'use strict';

var _ = require('lodash');
var FlightComponentVisibilityManagerService = function FlightComponentVisibilityManagerService(rangesCalculatorService, featureToggleService, currentStateCriteriaService, flightModeService) {
  var selectedBrushes = {};
  var notSelectedBrushes = {};
  var selectedDefaultBrushes = {};
  var appliedBrushes = {};
  var flightChartVisible = false;
  var profileChartVisible = false;
  var classMixChartVisible = false;
  var flowMixChartVisible = false;
  var serviceGridEnabled = false;
  var compFareChartSelected = false;
  var service = {
    thematicChartVisible: true,
    dateRangeCollapsed: true
  };
  function resetVisibility() {
    selectedBrushes = {};
    notSelectedBrushes = {};
    selectedDefaultBrushes = {};
    appliedBrushes = {};
    setChartsVisibility();
  }

  // due to hidden LAST_YEAR bar, singleElementSelected checker isn't working properly
  function filterLastYearValues(items) {
    items = Array.isArray(items) ? items : [];
    return _.filter(items, function (item) {
      return !_.includes(item, 'LAST_YEAR');
    });
  }
  function singleElementSelected(items) {
    return items && Array.isArray(items.barsWithData) && filterLastYearValues(items.filterArguments[0]).length === 1 && items.barsWithData.length > 0;
  }
  function setChartsVisibility() {
    appliedBrushes = _.assign({}, selectedDefaultBrushes, selectedBrushes);
    if (!_.isEmpty(selectedBrushes)) {
      _.forEach(selectedDefaultBrushes, function (brush, index) {
        if (selectedBrushes[index]) {
          notSelectedBrushes[index] = _.difference(brush.filterArguments[0], selectedBrushes[index].filterArguments[0]);
        }
      });
    }
    var isOneDaySelected = appliedBrushes.dateRange && rangesCalculatorService.getOnlyOneDaySelected(appliedBrushes.dateRange.filterArguments[0]);
    var isSingleVisibleLegSelected = singleElementSelected(appliedBrushes.legs);
    var isSingleCabinSelected = singleElementSelected(appliedBrushes.cabin);
    var isVisibleCabinSelected = appliedBrushes.cabin && appliedBrushes.cabin.barsWithData.length > 0;
    var isLastYearDataBarSelected = _.isUndefined(_.get(appliedBrushes.flightLevel, ['secondaryData', 0, 'flightId']));
    var isSingleFlightSelected = singleElementSelected(appliedBrushes.flightLevel) && !isLastYearDataBarSelected;
    flightChartVisible = isSingleVisibleLegSelected;
    flowMixChartVisible = isOneDaySelected && isSingleVisibleLegSelected && isSingleFlightSelected;
    profileChartVisible = flowMixChartVisible && isSingleCabinSelected;
    classMixChartVisible = !!appliedBrushes.profileChart;
    serviceGridEnabled = isOneDaySelected && isVisibleCabinSelected && isSingleVisibleLegSelected;
    service.dateRangeCollapsed = !classMixChartVisible;
    service.thematicChartVisible = !classMixChartVisible;
  }
  function setBrushFilters(brushFilters) {
    selectedBrushes = brushFilters;
    setChartsVisibility();
  }
  function setDefaultBrushFilters(brushFilters) {
    selectedDefaultBrushes = brushFilters;
    setChartsVisibility();
  }
  function setCompFareChartVisibility(visibility) {
    compFareChartSelected = visibility;
  }
  function isFlightLevelChartVisible() {
    return flightChartVisible;
  }
  function isFlowMixChartVisible() {
    return flowMixChartVisible;
  }
  function isProfileChartVisible() {
    return profileChartVisible;
  }
  function isBidPriceGraphVisible() {
    var isPostDepartureMode = currentStateCriteriaService.isPostDeparture() || false;
    var isSegmentClassControlEnabled = featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL');
    return profileChartVisible && !(isSegmentClassControlEnabled && isPostDepartureMode) && !flightModeService.isDAOnlyMode();
  }
  function isClassMixChartVisible() {
    return classMixChartVisible && !flightModeService.isDAOnlyMode();
  }
  function isServiceGridEnable() {
    return serviceGridEnabled;
  }
  function getAppliedBrushed() {
    return appliedBrushes;
  }
  function getSelectedBrushes() {
    return selectedBrushes;
  }
  function getNotSelectedBrushes() {
    return notSelectedBrushes;
  }
  function isCompFareChartVisible() {
    return !!(profileChartVisible && compFareChartSelected);
  }
  return _.assign(service, {
    setDefaultBrushFilters: setDefaultBrushFilters,
    setBrushFilters: setBrushFilters,
    setCompFareChartVisibility: setCompFareChartVisibility,
    getAppliedBrushed: getAppliedBrushed,
    getSelectedBrushes: getSelectedBrushes,
    getNotSelectedBrushes: getNotSelectedBrushes,
    resetVisibility: resetVisibility,
    isFlightLevelChartVisible: isFlightLevelChartVisible,
    isFlowMixChartVisible: isFlowMixChartVisible,
    isProfileChartVisible: isProfileChartVisible,
    isBidPriceGraphVisible: isBidPriceGraphVisible,
    isClassMixChartVisible: isClassMixChartVisible,
    isServiceGridEnable: isServiceGridEnable,
    isCompFareChartVisible: isCompFareChartVisible
  });
};
FlightComponentVisibilityManagerService.$inject = ['RangesCalculatorService', 'FeatureToggleService', 'CurrentStateCriteriaService', 'FlightModeService'];
module.exports = FlightComponentVisibilityManagerService;